var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.77083 0C8.56657 0 10.2888 0.73497 11.5585 2.04323C12.8283 3.35148 13.5417 5.12586 13.5417 6.97601C13.5417 8.70392 12.9271 10.2923 11.9167 11.5158L12.1979 11.8056H13.0208L18.2292 17.1717L16.6667 18.7816L11.4583 13.4154V12.5676L11.1771 12.2778C9.94849 13.3583 8.38616 13.9519 6.77083 13.952C4.9751 13.952 3.25291 13.2171 1.98313 11.9088C0.713353 10.6005 0 8.82616 0 6.97601C0 5.12586 0.713353 3.35148 1.98313 2.04323C3.25291 0.73497 4.9751 0 6.77083 0V0ZM6.77083 2.14647C4.16667 2.14647 2.08333 4.29293 2.08333 6.97601C2.08333 9.65909 4.16667 11.8056 6.77083 11.8056C9.375 11.8056 11.4583 9.65909 11.4583 6.97601C11.4583 4.29293 9.375 2.14647 6.77083 2.14647Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchicon);
export default __webpack_public_path__ + "static/media/searchicon.10e39072.svg";
export { ForwardRef as ReactComponent };